<template>
	<div class="certificate-list">
		<b-row class="">
			<b-col cols="3">
				<b-form-select
					v-model="filterCurrencyId"
					:options="refCurrencies"
					value-field="id"
					text-field="name"
					@change="currencyChanged"
				>
					<template slot="first">
						<option :value="null">-- Все валюты --</option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="3">
				<multiselect
					v-model="filter.departmentId"
					:options="listWarehouse"
					:multiple="true"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				/>
				<b style="display: inline-block">Вся фирма:</b>
				<b-checkbox class="ml-2 mb-1" style="display: inline-block" v-model="allDep" switch/>
			</b-col>
			<b-col :cols="companyType === 'SHOP' ? 3 : 3" v-if="companyType !== 'SHOP' ">
				<b-form-select
					v-model="filter.category"
					:options="allCategory"
					value-field="id"
					text-field="name"
					:disabled="disabled"
					@change="categorySelected"
				>
					<template slot="first">
						<option value="all">-- Все Категории --</option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="3">
				<b-form-select
					v-model="subcategory.value"
					:disabled="subcategory.isDisabled"
					@change="subCategorySelected"

				>
					<option v-for="(selectOption, indexOpt) in subcategory.items"
							:key="indexOpt"
							:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">--
							{{ companyType === 'SHOP' ? $t('client.create.customer') : 'Все Подкатегории' }} --
						</option>
					</template>
				</b-form-select>

			</b-col>
			<b-col :cols="companyType === 'SHOP' ? 3 : 3">
				<b-form-select
					v-model="subsubcategory.value"
					:disabled="subsubcategory.isDisabled"
					@change="subsubCategorySelected"

				>
					<option v-for="(selectOption, indexOpt) in subsubcategory.items"
							:key="indexOpt"
							:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">--
							{{ companyType === 'SHOP' ? $t('client.create.category') : 'Все Подкатегории' }} --
						</option>
					</template>
				</b-form-select>

			</b-col>
			<b-col cols="3">
				<b-form-select
					v-model="sub3category.value"
					:disabled="sub3category.isDisabled"

				>
					<option v-for="(selectOption, indexOpt) in sub3category.items"
							:key="indexOpt"
							:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">--
							{{ companyType === 'SHOP' ? $t('goods.subcategory') : 'Все Подкатегории' }} --
						</option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="3">
				<b-form-input id="name"
							  v-model="filter.name"
							  name="name"
							  :placeholder="$t('section.create-section-type.name') +'/'+ $t('goods.artikul')"
							  :disabled="disabled"
							  v-on:keyup.enter="accept"

				>
				</b-form-input>
			</b-col>
			<b-col cols="3" class="">
				<b-form-input id="barcode"
							  v-model="filter.barCode"
							  name="barcode"
							  :placeholder="$t('goods.special-barcode')"
							  :disabled="disabled"
							  v-on:keyup.enter="accept"
				>
				</b-form-input>
			</b-col>
<!--			<b-col cols="3" class="">-->
<!--				<b-form-select-->
<!--					v-model="filter.brand"-->
<!--					:disabled="disabled"-->

<!--				>-->
<!--					<option v-for="(selectOption, indexOpt) in brands"-->
<!--							:key="indexOpt"-->
<!--							:value="selectOption.id"-->
<!--					>-->
<!--						{{ selectOption.name }}-->
<!--					</option>-->
<!--					<template slot="first">-->
<!--						<option :value="null">&#45;&#45; {{ $t('goods.brand') }} &#45;&#45;</option>-->
<!--					</template>-->
<!--				</b-form-select>-->

<!--			</b-col>-->
			<!-- DATE NING BITTASI QOLDIRILDI AYNAN O'SHA DATE DAGI OSTATKANI KO'RISH UCHUN 21.11.2019 -->
			<!-- <b-col cols="2">
				<b-input-group>
					<masked-input v-model="filter.start"
								  mask="11-11-1111"
								  class="ml-1 form-control form-control-sm"
								  :placeholder=" $t('warehouse.date.start')"
								  :disabled="disabled"
								  size="sm"

					/>
					<b-input-group-addon>
						<b-input-group-text>
							<i class="fa fa-calendar"></i>
						</b-input-group-text>
					</b-input-group-addon>
				</b-input-group>
			</b-col> -->
<!--			<b-col cols="2" class="pl-2 mt-1">-->
<!--				<b-input-group>-->
<!--					<masked-input v-model="filter.date"-->
<!--								  mask="11-11-1111"-->
<!--								  class="ml-1 form-control form-control-sm"-->
<!--								  :placeholder=" $t('warehouse.date.date')"-->
<!--								  :disabled="disabled"-->
<!--								  size="sm"-->
<!--					/>-->
<!--					<b-input-group-addon>-->
<!--						<b-input-group-text>-->
<!--							<i class="fa fa-calendar"></i>-->
<!--						</b-input-group-text>-->
<!--					</b-input-group-addon>-->
<!--				</b-input-group>-->
<!--			</b-col>-->
<!--			<b-col cols="2" class="pl-0 mt-1" v-if="companyType === 'SHOP' || categoryCode === 'MAGAZIN'">-->
<!--				<b-form-select-->
<!--					v-model="filter.gender"-->
<!--					:disabled="disabled"-->
<!--				>-->
<!--					<option v-for="(selectOption, indexOpt) in genders"-->
<!--							:key="indexOpt"-->
<!--							:value="selectOption.id"-->
<!--					>-->
<!--						{{ selectOption.name }}-->
<!--					</option>-->
<!--					<template slot="first">-->
<!--						<option :value="null">&#45;&#45; Пол &#45;&#45;</option>-->
<!--					</template>-->
<!--				</b-form-select>-->

<!--			</b-col>-->
<!--			<b-col cols="2" class="pl-0 mt-1">-->
<!--				<multiselect-->
<!--					v-model="colors.value"-->
<!--					:options="colors.items"-->
<!--					:disabled="disabled"-->
<!--					track-by="id"-->
<!--					:show-labels="false"-->
<!--					:allow-empty="true"-->
<!--					label="name"-->
<!--					:placeholder="$t('goods.create.color')"-->
<!--					class="multiselect-pricing"-->
<!--				>-->
<!--				</multiselect>-->
<!--			</b-col>-->
			<b-col cols="3" class="mt-1">
				<b-form-input id="barcode"
							  v-model="filter.multiBarcode"
							  name="barcode"
							  :placeholder="$t('goods.barcode')"
							  :disabled="disabled"
							  v-on:keyup.enter="accept"
				>
				</b-form-input>
			</b-col>
			<b-col cols="3" class="mt-1">
				<multiselect
					v-model="filter.contragentId"
					:disabled="disabled"
					:options="contragents"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="fullName"
					:placeholder="$t('incomeFilter.contragent')"
					class="multiselect-pricing"
				/>
			</b-col>

		</b-row>

		<!-- <b-row class="mb-3">
		</b-row> -->


		<hr>
	</div>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapState} from 'vuex';
import Multiselect from 'vue-multiselect'
import MaskedInput from 'vue-masked-input'
import ReferencesService from "../../../../services/references.sevice";
import {TokenService} from "../../../../services/storage.service"
import ContrAgentService from "../../../../services/contragent.service";

export default {
	name: 'Filter-Warehouse',

	props: {
		departments: {
			type: Array,
			default: []
		},
		loading: {
			type: Boolean,
			default: null
		},
	},
	components: {MaskedInput, Multiselect},
	data() {
		return {
			filterCurrencyId: null,
			filter: {
				departmentId: null,
				contragentId: null,
				date: '',
				depsId: [],
				barCode: null,
				name: null,
				category: 'all',
				gender: null,
				brand: null,
					multiBarcode: null
			},
			subcategory: {
				items: [],
				value: null,
				isDisabled: true,
			},
			subsubcategory: {
				items: [],
				value: null,
				isDisabled: true,
			},
			sub3category: {
				items: [],
				value: null,
				isDisabled: true,
			},
			colors: {
				items: [],
				value: null
			},
			companyType: '',
			allCategory: [],
			contragents: [],
			categoryCode: null,
			disabled: true,
			brands: [],
			genders: [],
			attr: {},
			allDep: false
		}
	},

	watch: {
		'allDep': {
			handler(d) {
				if (d) {
					this.filter.departmentId = []
					this.listWarehouse.forEach(e => {
						this.filter.departmentId.push(e)
					})
					this.disabled = false
				} else {
					this.filter.departmentId = null
					this.disabled = true
				}
			}
		},
		'filter.departmentId': {
			handler(v) {
				for (let i=0;i<v.length;i++){
					localStorage.setItem("TavarName",JSON.stringify(v[i].name))
				}
				if (Object.keys(this.filter.departmentId).length !== 0) {
					this.setCompanyType()
					if (this.companyType === 'SHOP') {
						this.subcategory.isDisabled = false

					}
					this.disabled = false

				} else {
					this.disabled = true
					if (this.companyType !== 'SHOP') {
						this.filter.category = 'all'
						this.categoryCode = null;
					}
					this.subcategory.value = null
					this.subsubcategory.value = null
					this.sub3category.value = null

					this.sub3category.isDisabled = true
					this.subcategory.isDisabled = true
					this.subsubcategory.isDisabled = true
				}
			}
		},
		'filter.category': {
			handler(newValue) {
				if (newValue === 'all') {
					this.subcategory.value = null
					this.subsubcategory.value = null
					this.sub3category.value = null
				}

			}
		},

	},

	computed: {
		...mapState('references', [
			'refCurrencies'
		]),
		listWarehouse() {
			return this.departments.filter(item => {
				return item;
				// if (this.filterCurrencyId) {
				// 	if (item.currencyId === this.filterCurrencyId) {
				// 		return item;
				// 	}
				// } else {
				// 	return item;
				// }
			})
		}
	},
	methods: {
		...mapActions('references', [
			'getReferenceChildren',
		]),
		currencyChanged(selectedCurrencyId) {
			let selectedDeps = this.departments.filter(dep => {
				if (selectedCurrencyId) {
					if (dep.currencyId === selectedCurrencyId) {
						return dep;
					}
				}
			})
			Vue.set(this.filter, "departmentId", selectedDeps);
		},
		async loadColors() {
			let response = await ReferencesService.getReferenceChildren(`color`);
			this.colors.items = response.data;

		},
		async loadCategory() {
			await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
				this.allCategory = response.data;
			})
		},
		/**+
		 * Load genders
		 */
		loadGenders() {
			ReferencesService.getReferenceChildren('GENDER').then(response => {
				this.genders = response.data;
			})
		},
		loadBrands() {
			ReferencesService.getReferenceChildren(`item_brand`).then(response => {
				this.brands = response.data;
			})
		},
		accept() {
			if (this.filter.departmentId !== null && Object.keys(this.filter.departmentId).length !== 0) {
				this.setFilterToComponent()
			} else {
				this.$vs.notify({
					title: 'Пожалуйста выберите Отдел',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		setFilterToComponent() {
			this.filter.depsId = []
			let depNames = []
			if (this.filter.departmentId) {
				if (Object.keys(this.filter.departmentId).length !== 0) {
					this.filter.departmentId.forEach(item => {
						this.filter.depsId.push(item.id)
						let tempForCurrency = {
							name: item.name,
							currencyName: item.currencyName
						}

						depNames.push(tempForCurrency)
					})
					let dataCustom = {
						page: 1,
						limit: 50,
						depIds: this.filter.depsId
					}
					this.disabled = false
					this.attr['departmentId'] = 10;
					this.attr['empty'] = false
					this.attr['depNames'] = depNames
					this.attr['depsId'] = dataCustom

					let str = `?depIds=${this.filter.depsId}
								&contragentId=${this.filter.contragentId !== null ? this.filter.contragentId.id : null}
								&catId=${this.filter.category}
								&date=${this.filter.date || null}
								&barcode=${this.filter.barCode || null}
								&name=${this.filter.name || null}
								&subId=${this.subcategory.value || null}
								&sub2Id=${this.subsubcategory.value || null}
								&sub3Id=${this.sub3category.value || null}
								&genderId=${this.filter.gender || null}
								&brandId=${this.filter.brand || null}
								&colorId=${this.colors.value ? this.colors.value.id : null}
								&multiBarcode=${this.filter.multiBarcode || null}`
					this.attr['link'] = str

					this.$emit('filter', this.attr);


				} else {
					this.disabled = true
					this.filter.category = 'all'
					this.subcategory.isDisabled = true
					this.subcategory.value = null
					this.subsubcategory.isDisabled = true
					this.subsubcategory.value = null
					this.attr['empty'] = true
					this.attr['departmentId'] = 10;
					this.filter.depsId = []

					this.attr['depNames'] = [];
					this.attr['departments'] = [];
					this.attr['depsId'] = [];
					this.attr['depsId'] = [];
					this.$emit('filter', this.attr);
				}
			} else {
				this.disabled = true
				this.filter.category = 'all'
				this.subcategory.isDisabled = true
				this.subcategory.value = null
				this.subsubcategory.isDisabled = true
				this.subsubcategory.value = null
				this.attr['empty'] = true
				this.attr['departmentId'] = 10;
				this.$emit('filter', this.attr);
				this.filter.depsId = []
				depNames = []
			}
		},
		setCategoryCode(value) {
			this.allCategory.filter(el => {
				if (el.id === value) {
					this.categoryCode = el.code
				}
			})
		},
		loadSubCategory(id) {
			ReferencesService.getSubReferenceChildren(id).then(response => {
				this.subcategory.items = response.data;
			})
		},
		loadSubSubCategory(id) {
			ReferencesService.getSubReferenceChildren(id).then(response => {
				this.subsubcategory.items = response.data;
			})
		},
		loadSub3Category(id) {
			ReferencesService.getSubReferenceChildren(id).then(response => {
				this.sub3category.items = response.data;
			})
		},

		categorySelected() {

			if (this.filter.category !== 'all') {
				this.subcategory.isDisabled = false
				this.loadSubCategory(this.filter.category)
				this.subcategory.isDisabled = false
				this.subcategory.value = null

			} else {
				this.subcategory.isDisabled = true
				this.subcategory.value = null

			}

			this.setCategoryCode(this.filter.category);
			this.subsubcategory.isDisabled = true
			this.subsubcategory.value = null
			this.sub3category.isDisabled = true
			this.sub3category.value = null

		},
		subCategorySelected() {

			if (this.subcategory.value !== null) {
				this.subsubcategory.isDisabled = false
				this.subsubcategory.value = null
				this.loadSubSubCategory(this.subcategory.value)
			} else {
				this.subsubcategory.isDisabled = true
				this.subsubcategory.value = null

			}
			this.sub3category.isDisabled = true
			this.sub3category.value = null

		},
		subsubCategorySelected() {

			if (this.subsubcategory.value !== null) {
				this.sub3category.isDisabled = false
				this.sub3category.value = null
				this.loadSub3Category(this.subsubcategory.value)
			} else {
				this.sub3category.isDisabled = true
				this.sub3category.value = null

			}

		},

		setCompanyType() {
			this.companyType = TokenService.getDepartmentType()
			if (this.companyType === 'SHOP') {
				this.allCategory.filter(el => {
					if (el.code === 'MAGAZIN') {
						this.filter.category = el.id
					}
				})

				this.loadSubCategory(this.filter.category)
				//this.subcategory.isDisabled = false;
			}

		},
		async loadContracts() {
			let payload = {
				page: 1,
				limit: 1000
			}
			await ContrAgentService.searchContragent(payload).then(res => {
				this.contragents = res.data.items;
			})
		}

	},
	async created() {
		await this.getReferenceChildren('CURRENCY');
		await this.loadCategory()
		this.setCompanyType();
		this.loadGenders();
		this.loadBrands();
		await this.loadColors();
		await this.loadContracts();
	},

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.editBtn {
	font-size: 14px;
	cursor: pointer;
}

.filter-frame {
	padding-bottom: 15px;
}

.slide-enter, .slide-leave-to {
	transform: scaleY(0);
}

.certificateGenerate {
	background: transparent !important;
	border: none;
	padding: 7px;
	font-size: 16px;
}

.certificateGenerate span {
	margin-left: 5px;
}

.top-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.search_btn {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	padding-right: 25px
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
</style>
